"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.creditCards = void 0;
var creditCards = {
  offer_api: '/marketplace/offers/v0/credit_cards/search'
};
exports.creditCards = creditCards;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJjcmVkaXRDYXJkcyIsIm9mZmVyX2FwaSIsImV4cG9ydHMiXSwic291cmNlcyI6WyIuLi8uLi9zcmMvY29uc3RhbnRzL3VybHMuanMiXSwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGNvbnN0IGNyZWRpdENhcmRzID0ge1xuICBvZmZlcl9hcGk6ICcvbWFya2V0cGxhY2Uvb2ZmZXJzL3YwL2NyZWRpdF9jYXJkcy9zZWFyY2gnLFxufTtcbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQU8sSUFBTUEsV0FBVyxHQUFHO0VBQ3pCQyxTQUFTLEVBQUU7QUFDYixDQUFDO0FBQUNDLE9BQUEsQ0FBQUYsV0FBQSxHQUFBQSxXQUFBIn0=